<template>
  <section>
    <VTitle text="AppSheetAmenitiesViewer" />
    <div class="example-component">
      <div class="example-component__controls">
        <VPropControl
          v-for="(propModel, propName) in propModels"
          :key="propName"
          :model="propModel"
          :name="propName"
        />
      </div>
      <div class="example-component__component">
        <VComponentWrapper :width="375" bordered>
          <AppSheetAmenities
            :title="propModels.title.value"
            :features="propModels.features.value"
            :enter-to="propModels.enterTo.value"
            :tour360-to="propModels.tour360To.value"
          />
        </VComponentWrapper>
      </div>
    </div>
  </section>
</template>

<script>
import FeatureFactory from '@/classes/Feature/FeatureFactory'
import AppSheetAmenities from '@/components/UIKit/Standard/Organisms/AppSheet/AppSheetAmenities'
import AppPropModel from '@/components/UIKit/Standard/ViewerSections/classes/AppPropModel'
import VTitle from '@/components/UIKit/Standard/ViewerSections/components/snippets/VTitle'
import VPropControl from '@/components/UIKit/Standard/ViewerSections/components/snippets/VPropControl'
import VComponentWrapper from '@/components/UIKit/Standard/ViewerSections/components/snippets/VComponentWrapper'

export default {
  name: 'AppSheetAmenitiesViewer',
  components: {
    AppSheetAmenities,
    VTitle,
    VPropControl,
    VComponentWrapper,
  },
  data() {
    return {
      propModels: {
        title: new AppPropModel({
          type: String,
          defaultValue: 'AS3',
          required: true,
        }),
        features: new AppPropModel({
          type: Array,
          defaultValue: [],
          required: true,
        }),
        enterTo: new AppPropModel({
          type: Object,
          defaultValue: {},
          required: true,
        }),
        tour360To: new AppPropModel({
          type: Object,
          defaultValue: {},
        }),
      },
    }
  },
  created() {
    const demoFeaturesData = [
      {
        id: 'PARKING',
        value: 1,
        valueType: 'Integer',
        showInSmallPopup: true,
        position: 6,
      },
      {
        id: 'PARKING OPCIONAL',
        value: 1,
        valueType: 'Integer',
        showInSmallPopup: false,
        position: 7,
      },
      {
        id: 'BAR ROOFTOP',
        value: true,
        valueType: 'Boolean',
        showInSmallPopup: false,
        position: 1,
      },
      {
        id: 'GIMNASIO',
        value: true,
        valueType: 'Boolean',
        showInSmallPopup: false,
        position: 2,
      },
      {
        id: 'SKY LOUNGE',
        value: true,
        valueType: 'Boolean',
        showInSmallPopup: false,
        position: 3,
      },
      {
        id: 'YOGA & CROSSFIT',
        value: true,
        valueType: 'Boolean',
        showInSmallPopup: false,
        position: 4,
      },
      {
        id: 'DEN SOCIAL',
        value: true,
        valueType: 'Boolean',
        showInSmallPopup: false,
        position: 5,
      },
      {
        id: 'SAUNA',
        value: true,
        valueType: 'Boolean',
        showInSmallPopup: false,
        position: 10,
      },
      {
        id: 'ÁREA COMERCIAL',
        value: true,
        valueType: 'Boolean',
        showInSmallPopup: false,
        position: 10,
      },
      {
        id: 'SALÓN DE JUEGOS',
        value: true,
        valueType: 'Boolean',
        showInSmallPopup: false,
        position: 10,
      },
      {
        id: 'POKER ROOM',
        value: true,
        valueType: 'Boolean',
        showInSmallPopup: false,
        position: 10,
      },
      {
        id: 'JACUZZI',
        value: true,
        valueType: 'Boolean',
        showInSmallPopup: false,
        position: 10,
      },
      {
        id: 'VALET PARKING',
        value: true,
        valueType: 'Boolean',
        showInSmallPopup: false,
        position: 10,
      },
      {
        id: 'SEGURIDAD',
        value: true,
        valueType: 'Boolean',
        showInSmallPopup: false,
        position: 10,
      },
      {
        id: 'LOBBY',
        value: true,
        valueType: 'Boolean',
        showInSmallPopup: false,
        position: 10,
      },
      {
        id: 'BAR',
        value: true,
        valueType: 'Boolean',
        showInSmallPopup: false,
        position: 10,
      },
      {
        id: 'OPEN KITCHEN',
        value: true,
        valueType: 'Boolean',
        showInSmallPopup: false,
        position: 10,
      },
      {
        id: 'SALÓN DE BELLEZA',
        value: true,
        valueType: 'Boolean',
        showInSmallPopup: false,
        position: 10,
      },
      {
        id: 'PET SHOP',
        value: true,
        valueType: 'Boolean',
        showInSmallPopup: false,
        position: 10,
      },
      {
        id: 'FULL SPA',
        value: true,
        valueType: 'Boolean',
        showInSmallPopup: false,
        position: 10,
      },
    ]
    const featureFactory = new FeatureFactory()
    const features = demoFeaturesData.map((featureData) =>
      featureFactory.makeFeature(featureData, this.$i18n)
    )

    this.propModels.features.updateDefault(features.slice(4, 10))
    this.propModels.features.addPreset(features, 'Many features')
    this.propModels.features.addPreset([], 'Empty')
  },
}
</script>

<style lang="scss" scoped>
.example-component {
  display: flex;
  justify-content: stretch;
  align-items: stretch;

  @at-root &__controls {
    background: #fff;
    padding: 30px;
    border: 1px solid var(--gray-200);
    flex-basis: 300px;
    border-radius: 12px;
  }

  @at-root &__component {
    padding: 0 30px;
  }
}
</style>
